import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function FounderSectionMUI() {
	return (
		<Container
			maxWidth={false}
			sx={{
				width: { xs: "95%", md: "min(1500px, 95%)" },
				py: { xs: 6, md: 10 },
				px: { xs: 0, md: 8, lg: 12 },
			}}
		>
			<Grid
				container
				spacing={{ xs: 4, md: 0 }}
				alignItems="center"
				justifyContent="space-between"
			>
				{/* LEFT: Text Section */}
				<Grid
					size={{ xs: 12, md: 5 }}
					sx={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						gap: { xs: 1, md: 1.5 },
						pr: { md: 4, lg: 6 },
					}}
				>
					<Typography
						fontFamily="'Source Sans Pro', system-ui, sans-serif"
						fontWeight={300}
						fontSize={14}
						letterSpacing={2}
						color="#674934"
					>
						FOUNDER
					</Typography>

					<Typography
						component="h2"
						fontFamily="'Lora', serif"
						fontWeight={500}
						fontSize={{ xs: 32, md: 44 }}
						lineHeight={1.1}
						color="#674934"
					>
						Muskan Khan
					</Typography>

					<Typography
						fontFamily="'Source Sans Pro', system-ui, sans-serif"
						fontWeight={400}
						fontSize={18}
						color="#674934"
					>
						Principal Designer
					</Typography>

					<Box sx={{ mt: 2 }}>
						<Typography
							fontFamily="'Source Sans Pro', system-ui, sans-serif"
							fontWeight={400}
							fontSize={17}
							lineHeight={1.55}
							color="#674934"
							sx={{ maxWidth: "65ch" }}
						>
							Muskan Khan is the visionary behind Saffron House, a premier
							interior design studio based in Indore. With a passion for curated
							aesthetics and functional elegance, she leads every project with
							creativity and attention&nbsp;to&nbsp;detail.
						</Typography>
					</Box>
				</Grid>

				{/* RIGHT: Image */}
				<Grid
					size={{ xs: 12, md: 7 }}
					sx={{
						display: "flex",
						justifyContent: { xs: "center", md: "flex-end" },
						pl: { md: 4, lg: 6 },
					}}
				>
					<Box
						sx={{
							width: { xs: "80%", sm: "70%", md: "90%" },
							maxWidth: 500,
							borderRadius: 2,
							boxShadow: "0 6px 24px rgba(0,0,0,.08)",
							overflow: "hidden",
						}}
					>
						<Box
							component="img"
							src="/images/Muskan-Khan-Profile.jpg"
							alt="Muskan Khan"
							sx={{
								width: "100%",
								height: "100%",
								display: "block",
								objectFit: "cover",
							}}
						/>
					</Box>
				</Grid>
			</Grid>
		</Container>
	);
}
